export default [{
  path: 'boughtgoods/:leftid',
  name: 'merchant_boughtgoods',
  component: () => import('@/views/merchant/admin/bought/list'),
  meta: {
    tpflag: 'merchant',
    title: '已购产品',
  }
}, {
  path: 'boughtdetail/:leftid',
  name: 'merchant_boughtdetail',
  component: () => import('@/views/merchant/admin/bought/detail'),
  meta: {
    tpflag: 'merchant',
    title: '项目详情',
  }
}]



// WEBPACK FOOTER //
// ./src/router/user/_bought.js